import { PropsWithChildren } from "react";
import Image from "next/image";

type PageGradientWrapperProps = PropsWithChildren<{}>;

export const PageGradientWrapper = ({ children }: PageGradientWrapperProps) => (
  <div className="sc-page-gradient-wrap">
    <div className="sc-page-gradient-wrap__img-wrap">
      <div className="sc-page-gradient-wrap__img">
        {/*<Image width={2800} height={1418} src="/img/gradient-bg.jpg" quality={100} alt="" />*/}
      </div>
    </div>
    <div className="sc-page-gradient-wrap__inner">{children}</div>
  </div>
);
